/**
 * Foundations Skill Area
 * Lessons focused on daily habits, focus, and foundational skills
 */

export { dailyPulse } from './daily-pulse';
export { focusReset } from './focus-reset';

import { dailyPulse } from './daily-pulse';
import { focusReset } from './focus-reset';
import type { LessonDefinition } from '../types';

export const foundationsLessons: LessonDefinition[] = [
  dailyPulse,
  focusReset,
];
